import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    active: 'Active',
    unqualified: 'Unqualified',
    unqualifiedTooltip:
      'This pool does not yet have enough liquidity to qualify for reward production. Nevertheless, you can delegate your MAT to help bring this pool closer to qualification.',
  },
};
